<div class="addrecord-container">
  <div class="record-title">
    <h1>{{ 'shared.addRecord' | translate }}</h1>

    <button mat-button mat-dialog-close class="close-icon">
      <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon
        ><span>{{ 'shared.close' | translate }}</span>
      </button>
    </div>

    <div class="recordtitle-content">
      <div mat-dialog-content>
        <div class="recordsearch-bar">
          <mat-form-field (keydown.enter)="searchRecord()" appearance="outline">
            <input
              matInput
              type="text"
              autocomplete="no-autofill"
              [placeholder]="'shared.searchRecord' | translate"
              [formControl]="searchRecordFC"
              />
              <!-- <i class="fa fa-search recordsearchicon"></i> -->
              <mat-icon class="search">search</mat-icon>
            </mat-form-field>
          </div>
          <div class="records">
            <table [formGroup]="recordFormGroup" aria-hidden="true">
              <thead class="export-labels">
                <tr>
                  <th scope="col">{{ 'shared.sRecordType' | translate }}</th>
                  <th scope="col">{{ 'shared.sRecordID' | translate }}</th>
                  <th scope="col">{{ 'shared.recordAddress' | translate }}</th>
                </tr>
              </thead>
              <tbody class="export-input">
                <tr>
                  <th scope="col">
                    <mat-form-field appearance="outline">
                      <mat-select [formControl]="recordTypeId" disableOptionCentering>
                        @for (recordType of recordTypeOptions; track recordType) {
                          <mat-option [value]="recordType.key"
                            >{{ recordType.value | uppercase }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </th>
                  <th scope="col">
                    <mat-form-field appearance="outline">
                      <input matInput type="number" miqOnlyNumbers autocomplete="no-autofill" [formControl]="recordID" />
                    </mat-form-field>
                  </th>
                  <th scope="col">
                    <mat-form-field appearance="outline">
                      <input matInput type="text" autocomplete="no-autofill" [formControl]="recordDesc" />
                    </mat-form-field>
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div mat-dialog-actions>
        <button class="btn-submit" (click)="addRecord()" [disabled]="!recordFormGroup.valid">
          {{ 'shared.sAdd' | translate }}
        </button>
      </div>
    </div>
